import React, { useState, useEffect } from 'react';
import { Lightbulb } from 'lucide-react';
import facts from '../data/uselessFacts.json';
import LikeButton from './LikeButton';
import ShareButton from './ShareButton';
import { trackContentView, trackNextContent } from '../utils/analytics';

const UselessFact = () => {
  const [fact, setFact] = useState<{fact: string; source: string; date: number} | null>(null);

  const generateNewFact = () => {
    const randomIndex = Math.floor(Math.random() * facts.facts.length);
    const newFact = facts.facts[randomIndex];
    setFact(newFact);
    trackNextContent('Useless Fact');
    trackContentView('Useless Fact', newFact.fact);
  };

  useEffect(() => {
    generateNewFact();
  }, []);

  if (!fact) return null;

  return (
    <div className="card hover-lift p-6 group">
      <div className="flex items-center space-x-2 mb-6">
        <div className="p-2 rounded-lg bg-gradient-to-br from-yellow-500/20 to-orange-500/20 group-hover:from-yellow-500/30 group-hover:to-orange-500/30 transition-colors">
          <Lightbulb className="h-6 w-6 text-yellow-400" />
        </div>
        <h3 className="text-xl font-semibold gradient-text">Random Useless Fact</h3>
      </div>
      <p className="text-gray-300 mb-6 min-h-[80px] leading-relaxed">{fact.fact}</p>
      <div className="flex justify-between items-center text-sm">
        <div className="flex items-center space-x-2">
          <LikeButton type="fact" content={fact.fact} />
          <ShareButton 
            title="Check out this useless fact!"
            text={fact.fact}
          />
        </div>
        <button 
          onClick={generateNewFact}
          className="text-yellow-400 hover:text-yellow-300 transition flex items-center space-x-1 group"
        >
          <span>Next Fact</span>
          <span className="transform group-hover:translate-x-1 transition-transform">→</span>
        </button>
      </div>
    </div>
  );
};

export default UselessFact;